<div [class.disable-hint]="disableHint()"
     [class.editable]="editable()"
     [class.error]="invalid()"
     [class.icon-right]="iconRight()"
     [class.icon]="iconName()"
     [class.table-input]="tableInput()"
     [class.with-label]="label() && iconName()"
     [style.max-width]="maxWidth()"
     class="work-ui-input-field work-input">
  <div class="work-ui-input-field__header">
    @if (label()) {
      <label [for]="id()">
        <small><b>{{ label() | translate }} @if (required()) {
          <b class="work-text-required-asterisk"> *</b>
        }</b></small>
      </label>
    }
    @if (showMaxLengthCounter() && !!maxLength() && hasFocus()) {
      <div class="work-input__maxlength-hint">
        <small class="work-text-color-light">{{ currentCharLength() }}/{{ maxLength() }}</small>
      </div>
    }
  </div>
  <div class="input-wrapper"
       [workUiPopover]="popoverTemplate"
       [workUiPopoverTrigger]="null"
       [workUiPopoverMaxHeight]="400"
       [workUiPopoverWidth]="'fitParent'"
       [(workUiPopoverVisible)]="dropDownOpen">
    <input #inputFieldSearch
           (blur)="onSearchFieldBlur()"
           (input)="updateValue($event)"
           (focus)="onSearchFieldFocus()"
           [(ngModel)]="valueLabel"
           autocomplete="work-no-autofill"
           [disabled]="disabled()"
           [name]="name()"
           [maxLength]="maxLength() ?? null"
           [placeholder]="placeholder() | translate"
           [readonly]="readonly()"
           [required]="required()"
           [style.max-width]="maxWidth()"
           type="text"
           workUiAutoInitialWidthInputField />
    <input #inputField
           [disabled]="true"
           [id]="id()"
           [maxLength]="maxLength() ?? null"
           [max]="max()"
           [min]="min()"
           [name]="name()"
           [placeholder]="placeholder() | translate"
           [readonly]="readonly()"
           [required]="required()"
           [style.max-width]="maxWidth()"
           [value]="value()"
           type="hidden" />
    <work-ui-loading-spinner [(loadingState)]="loadingState"
                             [iconSize]="16" />

    <!-- dropdown behaviour-->
    @if (dropdownShowArrow() && !readonly()) {
      <work-ui-icon (click)="inputFieldSearch.focus(); dropDownOpen.set(true)"
                    class="dropdown-toggle"
                    name="expand_more" />
    }
    <ng-template #popoverTemplate>
      <work-ui-dropdown-list #dropdown
                             (optionSelected)="emitOptionChange($event)"
                             [(activeStringValue)]="valueLabel"
                             [(dropDownOpen)]="dropDownOpen"
                             [dynamicDropdownOptions]="dynamicDropdownOptions()"
                             [initialOption]="{value: value(), label: valueLabel()}"
                             [options]="dropdownOptions()" />
    </ng-template>
    @if (iconName()) {
      <work-ui-icon [name]="iconName()" />
    }

    @if (showClearButton() && value()) {
      <div (click)="clear()"
           [class.fade-in]="loadingState() === 'none'"
           [class.fade-out]="loadingState() !== 'none'"
           class="work-ui-input-field__clear">
        <work-ui-icon name="cancel" />
      </div>
    }
  </div>

  @if (!disableHint()) {
    <span
      [class.hide]="hideHint()"
      [style.opacity]="invalid() ? '1' : '0'" class="work-input__hint">
      <small><b>{{ hintMessage() || '-' | translate }}</b></small>
    </span>
  }
</div>
